// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3m2vz","clinicsSelect":"TableHeading_clinicsSelect__2iNXo"};